import { render, staticRenderFns } from "./GlobalSearchResultPerson.vue?vue&type=template&id=4dc7fcf8"
import script from "./GlobalSearchResultPerson.vue?vue&type=script&lang=js"
export * from "./GlobalSearchResultPerson.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports